/**
 * @module plugins/lazr
 * @requires module:common/classes/plugin~Plugin
 */
import { Plugin } from '@roskvartal-landings/base';

let observer;

/**
 * @classdesc Плагин ленивой загрузки изображений
 * @extends module:common/classes/plugin~Plugin
 * @inheritdoc
 * @hideconstructor
 */
class LazrPlugin extends Plugin {
  static init() {
    observer = new IntersectionObserver(
      LazrPlugin.replaceAttribute,
      LazrPlugin.config,
    );
    const elements = [...document.querySelectorAll('[data-lazr]')];
    elements.forEach((element) => {
      observer.observe(element);
    });
  }

  /**
   * @static
   * @method
   * @description Заменяет значение атрибута src на значение атрибута data-lazr
   * @param {IntersectionObserverEntry[]} entries - Элементы, для которых нужно произвести замену
   * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry
   */
  static replaceAttribute(entries) {
    entries.forEach((entry) => {
      if (
        Math.ceil(entry.intersectionRatio * 10) / 10
        >= LazrPlugin.config.threshold[0]
      ) {
        const { lazr } = entry.target.dataset;
        entry.target.setAttribute('src', lazr);
      }
      observer.unobserve(entry.target);
    });
  }
}
/**
 * @static
 * @member {Object}
 * @property {Number[]} threshold - Массив threshold
 * @description Объект конфигурации IntersectionObserver
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 */
LazrPlugin.config = {
  threshold: Array(10)
    .fill()
    .map((item, index) => index / 10),
};

export default LazrPlugin;
